import React from 'react';
import Header from './../Common/Header';
import Footer from './../Common/Footer';

import Team3 from '../Elements/Team3';
import Banner from './../Elements/Banner';
var bnrimg = require('./../../images/banner/1.jpg');

class Teams extends React.Component {
    render() {
        return (
            <>

                <Header />
                <div className="page-content">
                    <Banner title="Creating quality urban lifestyles, building stronger communities." pagename="Our Team" bgimage={bnrimg}/>
                  
                    <Team3 />
                 

                </div>

                <Footer />

            </>
        );
    };
};

export default Teams;